import React from 'react';
import { metricKeys } from '@pulse/metrics';
import humanizeValue from '@utils/humanizeUtil';
import { StyledCell } from './styled';
import { getTextColor } from '@src/utils/kpi/tools';

function ValueCell({ cellData, column }) {
  if (['NA', 'low'].includes(cellData)) {
    return <StyledCell>{cellData}</StyledCell>;
  }
  const textStyle: any = {};
  let classStr = '';
  if (column.dataKey === metricKeys.StreamingPerformanceIndex) {
    textStyle.color = getTextColor(cellData);
    textStyle.fontWeight = 600;
    classStr = 'color-critical';
  }
  const { humanizedNumber, humanizedUnit } = humanizeValue(cellData, column.metric);

  return (
    <StyledCell style={textStyle} className={classStr}>
      {`${humanizedNumber} ${humanizedUnit}`}
    </StyledCell>
  );
}

export default React.memo(ValueCell);
